import React from 'react';
import { StyleSheet, Text, View, Modal, TouchableOpacity, SafeAreaView, Platform } from 'react-native';
// import PlaidLink from '@burstware/expo-plaid-link';
import PlaidLink from '../components/PlaidLink';
import Button from '../components/Button';
import * as rtApi from '../components/Api';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { AntDesign } from '@expo/vector-icons';

const PlaidAccountSelect = (props) => {
  const [linkToken, setLinkToken] = React.useState(null);
  const [publicToken, setPublicToken] = React.useState(null);

  React.useEffect(() => {
    if (props.modalVisible) {
      createToken();
    }
  }, [props.modalVisible]);

  React.useEffect(() => {
    if(publicToken){
      exchangeToken();
    }
  }, [publicToken]);

  const createToken = async () => {
    rtApi.get('plaid/create_token')
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('createToken data: ', data);
      setLinkToken(data.link_token);
    }).catch(err => {
      console.log('createToken: ', err);
      props.setModalVisible(false);
    });
  }
  const exchangeToken = async () => {
    rtApi.get(`plaid/exchange_token?public_token=${publicToken}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('exchangeToken data: ', data);
      props.setAccessToken(data.access_token);
      props.setItemId(data.item_id);
      props.setModalVisible(false);
    }).catch(err => {
      console.log('exchangeToken: ', err);
    });
  }

  const onEvent = (e) => {
    console.log('onEvent', e);
  }
  const onExit = (e) => {
    console.log('onExit', e);
    props.setModalVisible(false);
  }
  const onSuccess = (e) => {
    console.log('onSuccess', e);
    setPublicToken(e.publicToken);
    props.setAccountId(e.metadata.accounts[0]._id);
    props.setAccountMask(e.metadata.accounts[0].meta.number);
    props.setMoneyMethod('direct deposit');
  }
 
  if(Platform.OS === 'web'){ return null; }
  return (

    <Modal
      style={{ backgroundColor: 'white' }}
      animationType="fade"
      transparent={true}
      visible={props.modalVisible}
      >
      <View style={styles.container}>
        <SafeAreaView>
          <View style={styles.linkContainer}>
            <PlaidLink
              linkToken={linkToken}
              onEvent={onEvent}
              onExit={onExit}
              onSuccess={onSuccess}
            />
          </View>
        </SafeAreaView>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    // flex: 1,
    backgroundColor: 'white',
  },
  linkContainer: {
    width: '100%',
    height: '100%',
  },
  account: {
    borderRadius: 10,
    padding: 10,
    marginTop: 10,
    width: '100%',
    backgroundColor: Colors.white,
    borderWidth: 1,
    borderColor: Colors.grey,
  },
  accountActive: {
    backgroundColor: Colors.blue2,
    borderColor: Colors.blue2,
  },
  number: {
    marginRight: 10,
  },
  amount: {
    marginLeft: 'auto',
  },
  row: {
    flexDirection: 'row',
    marginTop: 10,
  },
  accounts: {
    flex: 1,
    width: '100%',
  },
  accountsSelectContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    // justifyContent: 'center',
    backgroundColor: 'white',
    paddingHorizontal: 20,
  },
});

export default PlaidAccountSelect;